/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import * as React from "react";
import { consentStyles } from "../../styles/components/Consent/ConsentStyles";
import { ModalComponent } from "../ModalComponent";

interface IConsentComponent {
    disallowConsent(): void;
    dismissModal(): void;
}

export const ConsentModal: React.FC<IConsentComponent> = (props: IConsentComponent) => {
    return (
        <ModalComponent modalSize="small" onClickCloseHandler={props.dismissModal}>
            <div css={consentStyles.consentTitle}>
                Cancel Appointment?
            </div>
            <div css={consentStyles.consentSubTitle}>
                This session cannot continue due to lack of patient’s consent.
                <br></br>
                This appointment will be cancelled & booking amount will be refunded.
            </div>

            <div css={consentStyles.modalCtaContainer}>
                <button onClick={props.dismissModal} css={consentStyles.noBtn}>No</button>
                <button css={consentStyles.yesBtn} onClick={props.disallowConsent}>Yes</button>
            </div>
        </ModalComponent>
    )
}